module.exports = __webpack_public_path__ + "static/img/share.31d692cc.png";